import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/camelcase */
import { useEffect, useState } from "react";
import zh_CN from "./locale/zh_CN";
import en_US from "./locale/en_US";
import { useConfig } from "../_util/config-context";
import { translationMap } from "./translationMap";
// 约定中语言名不规范
var lngs = {
    zh: "zh_CN",
    en: "en_US",
    jp: "ja_JP",
    ko: "ko_KR",
};
export function setLocale() {
    console.error("`setLocale()` method is deprecated");
}
export function useTranslation(moment) {
    var configLocale = useConfig().locale;
    var t = typeof configLocale === "string"
        ? translationMap[configLocale] || zh_CN
        : __assign(__assign(__assign({}, zh_CN), en_US), configLocale);
    var locale = lngs[t.locale] || t.locale;
    useState(function () {
        if (moment) {
            moment.locale(locale);
        }
    });
    useEffect(function () {
        if (moment) {
            moment.locale(locale);
        }
    }, [locale]); // eslint-disable-line react-hooks/exhaustive-deps
    return t;
}
/* eslint-enable @typescript-eslint/camelcase */
//# sourceMappingURL=translation.js.map